import {debounce} from "../helpers/function_helpers";
import {getBreakPointByWidth} from "../plugins/breakpoints";

function inserted(el, binding) {
    setTimeout(() => {
        adaptStyle(el, binding);
    }, 0); // Wait for the next tick until the elements are rendered correctly

    window.addEventListener('resize', debounce(() => {
        adaptStyle(el, binding)
    }, 250), false) // Debounce to avoid costly calculations while the window size is in flux
}

function adaptStyle(el, binding) {
    if (!binding.value) {
        return;
    }

    const targetStyleProp = binding.arg || 'height'; // Can be 'height' or 'width'
    const plainTargetStyleProp = `offset${targetStyleProp.charAt(0).toUpperCase() + targetStyleProp.slice(1)}`;
    const bindingData = typeof binding.value === 'string' ? {selector: binding.value} : binding.value;

    const targetSelector = bindingData.selector;
    const targets = Array.prototype.slice.call(el.querySelectorAll(targetSelector));

    // We only match the element to the other elements in the row
    const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const currentBreakpoint = getBreakPointByWidth(windowWidth);
    const cellsPerRow = 12;
    const elementsPerRow = bindingData[currentBreakpoint] ? cellsPerRow / bindingData[currentBreakpoint] : targets.length;

    let i, j, chunkTargets;
    for (i = 0, j = targets.length; i < j; i += elementsPerRow) {
        chunkTargets = targets.slice(i, i + elementsPerRow);

        let highestStyle = 0;
        for (let i = 0; i < chunkTargets.length; i++) {

            // If the current element has a style, probably due to the previous style adapt, we temporarily remove it to get the plain style of the element
            const targetStyle = chunkTargets[i].style[targetStyleProp];
            chunkTargets[i].style[targetStyleProp] = null;

            const plainTargetStyle = chunkTargets[i][plainTargetStyleProp];
            if (plainTargetStyle > highestStyle) {
                highestStyle = plainTargetStyle;
            }

            // Set the original elements style as we already checked the plain style
            chunkTargets[i].style[targetStyleProp] = targetStyle;
        }

        for (let i = 0; i < chunkTargets.length; i++) {
            chunkTargets[i].style[targetStyleProp] = `${highestStyle}px`
        }
    }
}

function unbind() {
    window.removeEventListener('resize', adaptStyle)
}

function componentUpdated(el, binding) {
    adaptStyle(el, binding)
}

export const Adapt = {
    inserted,
    unbind,
    componentUpdated: debounce(componentUpdated, 150) // Debounce to avoid costly calculations when multiple updates occur
};

export default Adapt